import { getEnvVariable } from "../../../modules/environmentalList"

const accessdenied = {
    "type": "formcontainer",
    "key": "accessagencyusersform",
    "options": {
        "totalcolumns": 3,
        "totalrows": 9,
        "alignitem": "center",
        "title": "",
        "routes": {

            "route": "/registrationrequest",

            "exactRoute": true
        },
        //className: '',
        styles: {
            //margin: 15
        }, headerProps: {
            // "editbutton": false,
            //"savebutton": false,
            //  "backbutton": true,
            "closebutton": false,
            "navigateview": false,

        },
        "name": "agencyusersform",
        "crud": {
            "read": {
                "get": {
                    "url": getEnvVariable('MasterAdmin') + `/api/SelfRegistration/CurrentProfile`,
                }
            },
        },
    },
    "components": [
        // {
        //     "type": "formdropdown",
        //     "key": "AccountType",
        //     "options": {
        //         "row": 1,
        //         "col": 0,
        //         "width": 12,
        //         "label": "Account Type",
        //         "name": "AccountType",
        //         "crud": {
        //             "read": {
        //                 "get": {
        //                     "url": getEnvVariable('Admin') + `/api/Domains/values?domainkey=ACCOUNT_TYPE`
        //                 }
        //             }
        //         },
        //         "transformProps": {
        //             "value": "Value",
        //             "name": "Name"
        //         }
        //     }
        // },

        // {
        //     "type": "formtextbox",
        //     "key": "CompanyName",
        //     "options": {
        //         "row": 2,
        //         "col": 0,
        //         "width": 12,
        //         "label": "Company Name",
        //         "name": "CompanyName",
        //         "disabled": true,
        //         conditions: {
        //             enable: true,
        //         }
        //     },
        // },

        {
            "type": "formtextbox",
            "key": "AddressLine1",
            "options": {
                "row": 3,
                "col": 0,
                "width": 4,
                "label": "Address Line 1",
                "name": "AddressLine1",
                "disabled": true,
                conditions: {
                    enable: true,
                }
            },
            "inputProps": {
                "maxLength": 100
            }
        },
        {
            "type": "formtextbox",
            "key": "AddressLine2",
            "options": {
                "row": 3,
                "col": 1,
                "width": 4,
                "label": "Address Line 2",
                "name": "AddressLine2",
                "disabled": true,
                conditions: {
                    enable: true,
                }
            },
            "inputProps": {
                "maxLength": 100
            }
        },
        {
            "type": "formtextbox",
            "key": "City",
            "options": {
                "row": 4,
                "col": 1,
                "width": 4,
                "label": "City",
                "name": "City",
                "disabled": true,
                conditions: {
                    enable: true,
                }
            },
        },
        {
            "type": "formdropdown",
            "key": "State",
            "options": {
                "row": 4,
                "col": 1,
                "width": 4,
                "label": "State",
                "name": "State",
                "id": "statedropdown",
                "crud": {
                    "read": {
                        "get": {
                            "url": getEnvVariable('Admin') + `/api/Domains/values?domainkey=US_STATES`
                        }
                    }
                },
                "transformProps": {
                    "value": "Value",
                    "name": "Name"
                }
            },
        },
        {
            "type": "formtextbox",
            "key": "ZipCode",
            "options": {
                "row": 4,
                "col": 2,
                "width": 4,
                "label": "ZIP",
                "name": "ZipCode",
                "disabled": true,
                conditions: {
                    enable: true,
                }
            },
            "inputProps": {
                "maxLength": 100
            }
        },
        // {
        //     "type": "formtextbox",
        //     "key": "Country",
        //     "options": {
        //         "row": 5,
        //         "col": 0,
        //         "width": 12,
        //         "label": "Country",
        //         "name": "Country",
        //     },
        // },
        // {
        //     "type": "formdropdown",
        //     "key": "Primary Contact",
        //     "options": {
        //         "row": 6,
        //         "col": 0,
        //         "width": 12,
        //         "label": "Primary Contact",
        //         "name": "PrimaryContact",
        //         "crud": {
        //             "read": {
        //                 "get": {
        //                     "url": getEnvVariable('Admin') + `/api/Domains/values?domainkey=PRIMARY_CONTACT`
        //                 }
        //             }
        //         },
        //         "transformProps": {
        //             "value": "Value",
        //             "name": "Name"
        //         }
        //     }
        // },
        {
            "type": "formtextbox",
            "key": "OfficePhone",
            "options": {
                "row": 6,
                "col": 0,
                "width": 4,
                "label": "Phone",
                "name": "OfficePhone",
                "disabled": true,
                conditions: {
                    enable: true,
                }
            },
        },
        // {
        //     "type": "formtextbox",
        //     "key": "MobilePhone",
        //     "options": {
        //         "row": 6,
        //         "col": 1,
        //         "width": 4,
        //         "label": "Mobile Phone",
        //         "name": "MobilePhone",
        //         "disabled": true,
        //         conditions: {
        //             enable: true,
        //         }
        //     },
        //     "inputProps": {
        //         "maxLength": 100
        //     }
        // },
        // {
        //     "type": "formtextbox",
        //     "key": "HomePhone",
        //     "options": {
        //         "row": 6,
        //         "col": 2,
        //         "width": 4,
        //         "label": "Home Phone",
        //         "name": "HomePhone",
        //         "disabled": true,
        //         conditions: {
        //             enable: true,
        //         }
        //     },
        // },
        // {
        //     "type": "cautocompletetags",
        //     "key": "RequestedModules",
        //     "options": {
        //         "row": 7,
        //         "col": 0,
        //         "width": 12,
        //         "label": "Requested Modules:",
        //         "name": "RequestedModules",
        //         "crud": {
        //             "read": {
        //                 "get": {
        //                     "url": getEnvVariable('MasterAdmin') + `/api/module/${getEnvVariable('ModuleKey')}/submodule/All/Active/IsConfigurable`
        //                 }
        //             }

        //         },
        //         "transformProps": {
        //             "value": "Key",
        //             "name": "DisplayName"
        //         }
        //     }
        // },


    ]
}

export default accessdenied